import { POST } from '@wellsfargo/ecpfs-authority'

export const COMPONENT_DETAILS_PATH = 'login/getComponentDetails.json'

export function fetchComponentDetails(urlParams) {
	return POST(`${COMPONENT_DETAILS_PATH}${urlParams}`, {})
}
